import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import {
  FaDiscord,
  FaGamepad,
  FaRegHandRock,
  FaMask,
  FaBook,
} from "react-icons/fa";

import { FaNoteSticky } from "react-icons/fa6";
import FormField from "../components/FormField";

export const Step2 = ({ colors }) => {
  const { values } = useFormikContext();

  return (
    <div
      className="space-y-6 p-6 rounded-lg"
      style={{ backgroundColor: colors.background }}
    >
      <h3
        className="text-2xl font-semibold border-b pb-2"
        style={{ borderColor: colors.border }}
      >
        Utile à l'association
      </h3>

      <FormField
        name="idDiscord"
        label="Pseudo Discord"
        icon={FaDiscord}
        hasInfo={true}
        infoTitle=""
        info="Cette information est recueillie afin de pouvoir vous inviter à rejoindre le serveur Discord de l'association."
        required
      />

      <div>
        <span
          className="block text-sm font-medium mb-2"
          style={{ color: colors.text }}
        >
          <FaGamepad
            className="inline-block mr-2"
            style={{ color: colors.primary }}
          />
          Domaine de pratique <span style={{ color: colors.secondary }}>*</span>
        </span>
        <div className="space-y-2">
          {[
            { value: "Cosplay", icon: FaMask, label: "Cosplay" },
            {
              value: "Culture Geek",
              icon: FaGamepad,
              label: "Culture Geek",
            },
            {
              value: "Culture de l'imaginaire",
              icon: FaBook,
              label: "Culture de l'imaginaire",
            },
          ].map(({ value, icon: Icon, label }) => (
            <label key={value} className="inline-flex items-center mr-4">
              <Field
                type="checkbox"
                name="domainePratique"
                value={value}
                className="rounded"
                style={{
                  accentColor: colors.primary,
                  borderColor: colors.border,
                }}
              />
              <span className="ml-2" style={{ color: colors.text }}>
                <Icon
                  className="inline-block mr-1"
                  style={{ color: colors.primary }}
                />
                {label}
              </span>
            </label>
          ))}
        </div>
        <ErrorMessage
          name="domainePratique"
          component="div"
          className="mt-1 text-sm"
          style={{ color: colors.secondary }}
        />
      </div>

      <FormField
        name="motivation"
        label="Quelles sont vos motivations ?"
        icon={FaRegHandRock}
        as="textarea"
        rows={3}
        required
      />

      {/* Champ conditionnel pour Cosplay */}
      {values.domainePratique?.includes("Cosplay") && (
        <FormField
          name="cosplay"
          label="Quels sont tes cosplays ?"
          icon={FaNoteSticky}
          as="textarea"
          rows={3}
        />
      )}

      {/* Champ conditionnel pour Culture Geek */}
      {values.domainePratique?.includes("Culture Geek") && (
        <FormField
          name="cultureGeek"
          label="Quel est ton domaine favori dans la culture geek ?"
          icon={FaNoteSticky}
          as="textarea"
          rows={3}
        />
      )}

      {/* Champ conditionnel pour Culture de l'imaginaire */}
      {values.domainePratique?.includes("Culture de l'imaginaire") && (
        <FormField
          name="cultureImaginaire"
          label="Quels univers de l'imaginaire apprécies-tu le plus ?"
          icon={FaNoteSticky}
          as="textarea"
          rows={3}
        />
      )}
    </div>
  );
};
